"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgUserForwardFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M17 7A5 5 0 117 7a5 5 0 0110 0zM8.004 14C4.001 14 2 16 2 20c0 1.333.667 2 2 2h9.327a3.716 3.716 0 01-2.608-1.63c-.556-.834-.69-1.726-.69-2.358v-.017c-.003-.146-.018-1.009.384-1.87a3.657 3.657 0 011.353-1.548 3.802 3.802 0 011.8-.577H8.004z' }),
    react_1.default.createElement("path", { d: 'M17.24 20.356c-.317.412-.303.996.052 1.36.384.392 1.022.377 1.425-.036l2.97-3.038.087-.1c.316-.412.302-.996-.053-1.359l-2.833-2.898-.093-.084c-.388-.304-.96-.262-1.332.119l-.086.099c-.317.412-.303.996.052 1.359l1.422 1.454-2.21.002h-2.82C13 17.232 13 17.97 13 18.255c0 .483.222 1.023.821 1.023l4.461.002-.956.977-.086.1z' }))); };
exports.default = SvgUserForwardFilled;
//# sourceMappingURL=UserForwardFilled.js.map